import angular from 'angular';

export default angular.module('directives.busList', [])
  .component('busList', {
    template: require('./bus-list.template.html'),
    controller: ['$http',
      function BusListComponent($http) {
        var that = this;
        $http.get('data/buslist.json').then(function(response) {
          that.buslist = response.data;
        });
      }
    ]
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/bus-list/bus-list.component.js